<template>
    <div class="mx-auto row">
        <v-col class="col-md-4" v-for="(item, i) in searchResults" :key="i">
            <v-card color="#191179" dark class="text-white" max-height="400" elevation="4" :key="item.token">

                <div class="d-flex flex-no-wrap justify-space-between">
                    <div>
                        <v-card-title v-text="item.place" style="font-size: 9pt;font-weight: bold"></v-card-title>

                        <v-card-subtitle v-text="item.title"></v-card-subtitle>

                        <div class="row px-2">
                            <v-card-subtitle v-text="item.price"></v-card-subtitle>

                            <v-card-subtitle v-text="item.data"></v-card-subtitle>
                        </div>
                    </div>
                    <v-avatar class="ma-3" size="115">
                        <v-img :src="item.image ? item.image : require('@/assets/img/rblandNotext.png')"></v-img>
                    </v-avatar>
                </div>
            </v-card>
        </v-col>
    </div>
</template>

<script>
export default {
    name: "divarAdvertise",
    props: {
        searchResults: {
            require: true
        }
    }
}
</script>

<style scoped>

</style>